export default "__VITE_ASSET__C3WXuIG1__"